import { useEffect } from "react"

// Detects clicks outside of a component, and executes a handler function.
// Usage:
// Put this in the component:
//
//* const ref = useRef()
//* useOnClickOutside(ref, () => handleClickOutside())
//*
//* function handleClickOutside() {
//*   console.log("You clicked outside!")
//* }
//
// Then put "ref={ref}"" on the desired element. If we click anything other than this element or its children, the handler will be executed.
// Example:
//
//* <div ref={ref}>Click outside of me!</div>
//
export function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return
        }
        handler(event)
      }

      document.addEventListener("mousedown", listener, { passive: true })
      document.addEventListener("touchstart", listener, { passive: true })
      
      return () => {
        document.removeEventListener("mousedown", listener)
        document.removeEventListener("touchstart", listener)
      }
    },
    // Add ref and handler to useEffect dependencies.
    // Worth noting: because the passed handler is a new function on every render, that will cause this effect callback/cleanup to run every render.
    // It's not a big deal but to optimize you can wrap handler in useCallback before passing it into this hook.
    [ref, handler]
  )
}
